var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-tip",
    style: {
      width: "".concat(_vm.width),
      marginLeft: "".concat(_vm.mleft)
    }
  }, [_c('div', {
    staticClass: "musk"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.tipInfo))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };